import { SafeAreaInsets } from '@eika-infrastruktur/mobilbank-lib';

const getSafeAreaInsets = (): SafeAreaInsets =>
    window.ReactNativeProps?.safeAreaInsets ?? { top: 0, bottom: 0, left: 0, right: 0 };

export default getSafeAreaInsets;
